<div class="error-box">
    <h1>404</h1>
    <h3>No encontrado</h3>
</div>
